import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  copyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 16,
      height: 16,

      [theme.breakpoints.down('tablet')]: {
        width: 12,
        height: 12,
      },
    },
  },
}))

export { useStyles }
